// import { AppContext, ExAppContext } from '../Context';
import { /*useContext, useState, useRef, useEffect,*/ Fragment } from 'react';
import {
    PDFDownloadLink,
    PDFViewer,
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image,
    Font,
    BlobProvider,
} from "@react-pdf/renderer";

//graphics
import ECertBg from '../assets/images/general/ecert-bg.png';
import PPKMLogo from '../assets/images/logos/ppkmLogo2.png';

//fonts
import CapitalisTypOasis from '../assets/fonts/CapitalisTypOasis.ttf';
import ArialBold from '../assets/fonts/NetArialBold.ttf';

//controllers
// import DatabaseInterfaceController from '../controllers/DatabaseInterfaceController';

//classes
import Member from '../classes/member';
import MemberUser from '../classes/memberUser';
import MemberType from '../exClasses/memberType';
class AuthorityInfo {
    public name: string = '';
    public signature_url: string = '';
    public authority_type: number = 0; //0 - president, 1 - secretary

    constructor(name: string, signature_url: string, authority_stype: number) {
        this.name = name;
        this.signature_url = signature_url;
        this.authority_type = authority_stype;
    }
}

interface Props {
    presidentInfo: AuthorityInfo | null, secretaryInfo: AuthorityInfo | null,
    membership: Member, user: MemberUser, memberTypes: MemberType[],
    certDate: Date
}

const ECerticate: React.FC<Props> = ({
    presidentInfo,
    secretaryInfo,
    membership,
    user,
    memberTypes,
    certDate
}) => {
    //contexts
    // const appContext = useContext(AppContext);
    // const exAppContext = useContext(ExAppContext);
    //states
    // const [presidentInfo, SetPresidentInfo] = useState<AuthorityInfo | null>(null);
    // const [secretaryInfo, SetSecretaryInfo] = useState<AuthorityInfo | null>(null);

    //controller
    // const databaseController = new DatabaseInterfaceController(appContext);

    //objs
    Font.register({
        family: "CTO",
        fonts: [
            {
                src: CapitalisTypOasis, // Path to the .ttf file
                fontWeight: "normal", // Specify the weight (e.g., normal, bold)
            },
        ],
    });
    Font.register({
        family: "Arial Bold",
        fonts: [
            {
                src: ArialBold, // Path to the .ttf file
                fontWeight: "bold", // Specify the weight (e.g., normal, bold)
            },
        ],
    });

    //checking functions
    const IsCorporate = () => {
        if (
            membership.member_typeID == 'MTYPE-000001'
            || membership.member_typeID == 'MTYPE-000004'
        ) {
            return true;
        } else {
            return false;
        }
    }
    const IsAffiliate = () => {
        if (
            membership.member_typeID == 'MTYPE-000004'
            || membership.member_typeID == 'MTYPE-000005'
        ) {
            return true;
        } else {
            return false;
        }
    }

    const styles = StyleSheet.create({
        page: {
            backgroundColor: (IsCorporate() ? "#FCFCE0" : "#FFFFFF"),
            padding: 20,
        },
        image: {
            width: "450px",
            height: "auto",
            padding: "30px",
            marginTop: "15px",
            alignSelf: "center",
        },
        title: {
            fontSize: 30,
            fontWeight: "bold",
            fontFamily: "CTO",
            marginBottom: 50,
        },
        subtitle: {
            fontSize: 16,
            marginBottom: 10,
        },
        content: {
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            fontSize: 22,
            fontWeight: 900,
            fontFamily: "Arial Bold",
        },
        subcontent: {
            fontSize: 21,
            fontWeight: 900,
            marginBottom: 15,
            fontFamily: "Arial Bold",
        },
        content2: {
            fontSize: 12,
            fontWeight: "bold",
            marginBottom: 0,
            fontFamily: "Arial Bold",
        },
        content3: {
            fontSize: 12,
            fontWeight: 600,
            marginBottom: 10,
            fontFamily: "Arial Bold",
        },
        text: {
            fontSize: 14,
        },
        signatureContainer: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 20,
        },
        signatureSpace: {
            alignItems: "center",
            width: "50%",
        },
        signatureImage: {
            width: 150, // Adjust as needed
            height: 75, // Adjust as needed
            resizeMode: "contain",
            marginBottom: 10, // Add more space below the image
            paddingBottom: 5, // Space between the image and the border
            borderBottomWidth: 1, // Thickness of the border
            borderBottomColor: "#000", // Border color
        },
        content4: {
            fontSize: 12,
            fontWeight: "normal",
        },
        content5: {
            fontSize: 14,
            fontFamily: 'Arial Bold',
            fontWeight: 'bold'
        },
    });

    const GetMemberTypeLabelFromID = (memberTypeID: string) => {
        let res = '';
        memberTypes.map((type: MemberType) => {
            if (type.member_typeID == memberTypeID)
                res = type.label;
        });
        return res;
    }

    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>
                <Image
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        bottom: 8,
                        left: 8,
                        objectFit: "fill",
                    }}
                    src={ECertBg} // Replace with your image URL
                />

                {/* Certificate Content */}
                <View style={styles.content}>
                    <Image src={PPKMLogo} style={styles.image} />
                    <Text style={styles.title}>MEMBERSHIP CERTIFICATE</Text>
                    <Text style={styles.subtitle}>THIS IS TO CERTIFY THAT</Text>
                    {
                        IsCorporate() ?
                            <Fragment>
                                <Text style={styles.content}>{membership.company_name}{(membership.company_number.trim().length > 0 ? "(" + membership.company_number.trim() + ")" : '')}</Text>
                                {
                                    !IsAffiliate() ?
                                    <Text style={styles.subcontent}>({membership.complex_representing})</Text>
                                    :
                                    null
                                }
                                <Text style={styles.content2}>
                                    IS A CORPORATE MEMBER OF PERSATUAN PENGURUSAN KOMPLEKS MALAYSIA
                                    (PPK) FOR YEAR {certDate.getFullYear().toString()}
                                </Text>
                                <Text style={styles.content3}>({membership.memberID})</Text>
                            </Fragment>
                            :
                            <Fragment>
                                <Text style={styles.content}>{user.salutation} {user.name}</Text>
                                <Text style={styles.content2}>
                                    IS AN {GetMemberTypeLabelFromID(membership.member_typeID).toUpperCase()} MEMBER OF PERSATUAN
                                    PENGURUSAN KOMPLEKS MALAYSIA (PPK) FOR YEAR {certDate.getFullYear()}
                                </Text>
                                <Text style={styles.content3}>({membership.memberID})</Text>
                            </Fragment>
                    }
                </View>

                {/* Signature Container */}
                <View style={styles.signatureContainer}>
                    <View style={styles.signatureSpace}>
                        <Image
                            source={{ uri: (presidentInfo ? presidentInfo.signature_url : '') }}
                            style={styles.signatureImage}
                        />
                        <Text style={styles.content4}>President</Text>
                        <Text style={styles.content5}>{(presidentInfo ? presidentInfo.name : '')}</Text>
                    </View>
                    <View style={styles.signatureSpace}>
                        <Image
                            source={{ uri: (secretaryInfo ? secretaryInfo.signature_url : '') }}
                            style={styles.signatureImage}
                        />
                        <Text style={styles.content4}>Secretary</Text>
                        <Text style={styles.content5}>{(secretaryInfo ? secretaryInfo.name : '')}</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
}
export default ECerticate;